<template>
  <div>
     <portal target-el="#filter">
       <div>
         <button @click="save">
        Save
         </button>
       </div>
       </portal>
    <h1>Settings</h1>

    <div class="settings">
      <CheckboxGroup v-model="selectedFeatures">
        <Checkbox
        v-for="(value, key) in features"
        :label="key"
        :checked="value"
        :key="key" />
      </CheckboxGroup>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      selectedFeatures: [],
    };
  },

  computed: {
    ...mapGetters({
      isSettingsLoading: 'settings/isLoading',
      features: 'settings/features',
    }),
  },

  created() {
    this.$store.dispatch('settings/features');
  },

  methods: {
    async save() {
      const featureList = Object.keys(this.features);
      const selectedFeatures = this.selectedFeatures;
      const features = {};
      featureList.forEach((name) => {
        features[name] = selectedFeatures.indexOf(name) !== -1;
      });
      try {
        await this.$store.dispatch('settings/update', { features });
        this.$success({ message: 'Settings saved!!' });
      } catch (err) {
        this.$error({ message: 'Settings not saved!!' });
      }
    },
  },

};
</script>


<style lang="scss" scoped>
h1 {
  padding-top: 16px;
}
.settings {
  .el-checkbox {
    display: block;
    margin: 10px;
  }
}
</style>
